<template>
    <div class="block-editor webhook">
        <div class="wrapper">
            <span class="title">{{ $t("chatbotv2.webhookBlockPickerTitle") }}</span>
            <WebhookPicker v-model="clone.webhookId" />
        </div>
    </div>
</template>

<script>
import _ from "lodash";
import WebhookPicker from "../pickers/WebhookPicker";

export default {
    name: "WebHook",
    components: { WebhookPicker },
    props: ["value"],
    data() {
        return {
            clone: _.cloneDeep(this.value),
        };
    },
    watch: {
        clone: {
            handler(val) {
                this.$emit("input", val);
            },
            deep: true,
        },
    },
};
</script>

<style lang="scss">
.block-editor.webhook {
    margin-bottom: 50px;

    .wrapper {
        padding: 0 10px;
        width: 100%;
        display: flex;
        flex-direction: column;

        .title {
            margin-bottom: 5px;
            color: #22272d;
            font-weight: 600;
        }
    }
}
</style>
